export default __webpack_public_path__ + "static/media/234.de5eb720.gif";